import { useMutation } from '@tanstack/react-query'

import { identityServices } from '../identityServices'

export const useResendVerificationEmail = () =>
  useMutation({
    mutationFn: identityServices.resendVerificationEmail,
  })
